enum AccessBitPosition {
  micro = 5,
  video = 6,
  demonstration = 7,
  waitingHall = 13,
}

export default AccessBitPosition;
